import { Injectable, Inject } from '@angular/core';
import { Auth0Service } from './auth0.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Service to help transition from AngularJS Auth0 to Angular Auth0
 * Provides compatibility methods for existing AngularJS code
 */
@Injectable({
  providedIn: 'root'
})
export class AuthTransitionService {

  constructor(@Inject(Auth0Service) private auth0Service: Auth0Service) {}

  /**
   * Check if user is authenticated (compatible with AngularJS)
   * @returns boolean indicating authentication status
   */
  public isAuthenticated(): Observable<boolean> {
    return this.auth0Service.isAuthenticated$();
  }

  /**
   * Get current user (compatible with AngularJS)
   */
  public getCurrentUser(): Observable<any> {
    return this.auth0Service.getUser$();
  }

  /**
   * Get access token (compatible with AngularJS)
   */
  public getToken(): Observable<string | undefined> {
    return this.auth0Service.getAccessToken$();
  }

  /**
   * Login with redirect (compatible with AngularJS)
   */
  public login(isGlobal: boolean = false, requestedUrl?: string): void {
    if (isGlobal) {
      this.auth0Service.loginGlobal(requestedUrl);
    } else {
      this.auth0Service.loginRegular(requestedUrl);
    }
  }

  /**
   * Logout (compatible with AngularJS)
   */
  public logout(isGlobal: boolean = false): void {
    this.auth0Service.logout(isGlobal);
  }

  /**
   * Handle authentication callback
   */
  public handleCallback(): Observable<any> {
    return this.auth0Service.handleRedirectCallback$();
  }
}
